import { jsx as _jsx } from "react/jsx-runtime";
import { LeafLine } from "sprout-ui-icons";
import { PageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
const PostPageToolbarItemTodo = ()=>{
    return /*#__PURE__*/ _jsx(PageToolbarItem, {
        icon: LeafLine,
        label: "Leaf",
        action: "ADD_TODO"
    });
};
export default PostPageToolbarItemTodo;
